import {MIME_TYPE, SUPPORTED_DOCUMENTS_FORMAT} from '../consts'

export const isDocumentSupported = ({name}: File) =>
  SUPPORTED_DOCUMENTS_FORMAT.split(',').some((format) => name.toLowerCase().endsWith(format))

export const isPdf = (fileName: string) => fileName.endsWith('.pdf')

export const getMimeType = (filename: string): string => {
  const extension = filename.split('.').pop()?.toLowerCase()
  return extension && MIME_TYPE[extension] ? MIME_TYPE[extension] : 'application/octet-stream'
}

// Matches a leading URI scheme like `javascript:` or `data:` so only http(s) links are trusted
const SCHEME_PREFIX_REGEX = /^[a-zA-Z][a-zA-Z0-9+.-]*:/

/**
 * Returns a safe href for an external link, or undefined when it must not be linkified.
 * Allows only http(s); normalizes protocol-less links (e.g. `www.example.com`) to https
 * so they are not resolved as a relative path.
 */
export const getSafeExternalHref = (link: string | undefined): string | undefined => {
  const trimmed = link?.trim()
  if (!trimmed) return undefined

  if (/^https?:\/\//i.test(trimmed)) {
    try {
      const {protocol} = new URL(trimmed)
      return protocol === 'http:' || protocol === 'https:' ? trimmed : undefined
    } catch {
      return undefined
    }
  }

  return SCHEME_PREFIX_REGEX.test(trimmed) ? undefined : `https://${trimmed}`
}
